import '@fontsource-variable/inter';
import '../global.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AndroidUpdateBanner } from '@/components/layout/AndroidUpdateBanner';
import { installNativeAuthDeepLink } from '@/lib/auth/native-google-sign-in';
import { AuthProvider } from '@/lib/auth/session';

installNativeAuthDeepLink();

import { AppRoutes } from './App';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <div className="flex min-h-0 flex-1 flex-col">
      <AndroidUpdateBanner />
      <div className="flex min-h-0 flex-1 flex-col">
        <BrowserRouter>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </BrowserRouter>
      </div>
    </div>
  </StrictMode>,
);
